export default __webpack_public_path__ + "static/agency_kricp-2281d61e344615a03bdb021442f71ac9.jpg";